import React from "react";
import styled, { css } from "styled-components";
import { FormGroup } from "xsolla-uikit";

export default function PAContentBlock({
  border = "lg",
  wizard = null,
  title = null,
  width,
  children = null,
  nopadding = false,
  sticky,
  style,
}) {
  return ( <FormGroup indentation={border ? 'md' : 'md'} style={{marginBottom: 32, ...style}}>
    <FormGroup border={border}>

    {sticky !== 'undefined' && <CssSticky>{sticky}</CssSticky>}

    {/* <div
      style={{
        padding: `${wizard || nopadding ? "0" : "0 0 56px 0"}`
      }}
    > */}
        <div
          className={`${
            (!wizard || !nopadding)
              ? "ui-form__section ui-form__section--inline xsui-form-group--indentation-md ui-form__section--without-border"
              : ""
          }`}
          style={{
            padding: `${(wizard || nopadding) ? "0" : "0 0 36px 0"}`,
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
          }}
      >

          {!wizard && (
            <div className="ui-form__section__label"
              style={{position: 'static',
                minWidth: '25%',
                width: '100%',
                marginBottom: 16,
              }}
            >
              <div className="ui-form__section__label--flex">{title}</div>
            </div>
          )}

          <div className={!wizard && !nopadding ? "ui-form__section__content" : ""}

          style={{
                width: '100%',
              }}
          >

            {wizard && (
              <h3>
                {title}
              </h3>
            )}

            {children}
          </div>
        </div>
        {/* </div> */}
      </FormGroup>
    </FormGroup>
  );
}


const CssSticky = styled.div`
  position: sticky;
  right: 0;
  top: 0;
  width: 100px;

`


export function PAContentBlock2 ({
  border = "lg",
  wizard = null,
  title = null,
  children = null,
  nopadding = false,
}) {
  return (
    <div
      style={{
        padding: `${wizard || nopadding ? "0" : "0 0 56px 0"}`
      }}
    >

    <FormGroup border={wizard ? false : border} indentation="lg">

        <div
          className={`${
            !wizard
              ? "ui-form__section ui-form__section--inline xsui-form-group--indentation-md ui-form__section--without-border"
              : ""
          }`}
          style={{
            padding: (!wizard) ? '0px 0 36px 0' : null
          }}
      >

          {!wizard && (
            <div className="ui-form__section__label">
              <div className="ui-form__section__label--flex">{title}</div>
            </div>
          )}

          <div className={!wizard ? "ui-form__section__content" : ""}>

            {wizard && (
              <h3>
                {title}
              </h3>
            )}

            {children}
          </div>
        </div>
      </FormGroup>
    </div>
  );
}
